module.exports = __webpack_public_path__ + "img/section5_img2_5.9ce46be3.png";